import * as React from 'react';
import { Divider, TopBarBox } from './shared/_styles';
import FontSizeMutator from '@src/editor/Elements/TopBar/shared/FontSizeMutator';
import ZIndexMutator from '@src/editor/Elements/TopBar/shared/ZIndexMutator';
import StateMutator from '@src/editor/Elements/TopBar/shared/StateMutator';
import FontColorMutator from '@src/editor/Elements/TopBar/shared/FontColorMutator';
import IconTypeMutator from '@src/editor/Elements/TopBar/shared/IconTypeMutator';
import AlignmentMutators from '@src/editor/Elements/TopBar/shared/AlingmentMutators';
const IconMutators = () => {
    return (React.createElement(TopBarBox, null,
        React.createElement(ZIndexMutator, null),
        React.createElement(Divider, null),
        React.createElement(FontColorMutator, null),
        React.createElement(Divider, null),
        React.createElement(FontSizeMutator, null),
        React.createElement(Divider, null),
        React.createElement(AlignmentMutators, null),
        React.createElement(Divider, null),
        React.createElement(IconTypeMutator, null),
        React.createElement(StateMutator, null)));
};
export default IconMutators;
